module.exports = __webpack_public_path__ + "wallet.png?e3e750e9dfe8f694f5ef98f111db20ea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wallet.png
// module id = 47
// module chunks = 0